var $95697975ed728a4d$exports = {};
const $95697975ed728a4d$var$apiKey = "wH1aTA62Rv1D74uPnKlk5kP1VUKEYN03";
const $95697975ed728a4d$var$section = "science";
const $95697975ed728a4d$var$url = `https://api.nytimes.com/svc/topstories/v2/${$95697975ed728a4d$var$section}.json?api-key=${$95697975ed728a4d$var$apiKey}`;
const $95697975ed728a4d$var$articlesContainer = document.getElementById("articles");
const $95697975ed728a4d$var$footer = document.querySelector("footer");
async function $95697975ed728a4d$var$fetchArticles() {
    try {
        const response = await fetch($95697975ed728a4d$var$url);
        if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
        const data = await response.json();
        // Insert copyright dynamically
        if (data.copyright) {
            const copyrightElem = document.createElement("p");
            copyrightElem.className = "text-sm text-gray-400 mt-2";
            copyrightElem.textContent = data.copyright;
            $95697975ed728a4d$var$footer.appendChild(copyrightElem);
        }
        // Filter out empty articles
        const validArticles = data.results.filter((article)=>{
            return article.abstract && article.abstract.trim() !== "" || article.url && article.url !== "null";
        });
        validArticles.forEach((article)=>{
            const card = document.createElement("div");
            card.className = "article-card";
            // Pick a good image
            let imageUrl = "";
            if (article.multimedia && article.multimedia.length > 0) {
                const img = article.multimedia.find((m)=>m.format === "mediumThreeByTwo440") || article.multimedia[0];
                imageUrl = img.url;
            }
            // Build article HTML
            let cardHTML = `
        ${imageUrl ? `<img src="${imageUrl}" alt="${article.title}" class="w-full h-48 object-cover mb-4 rounded">` : ""}
        <h2 class="text-xl font-bold mb-2 text-cyan-400">${article.title}</h2>
        <p class="mb-2">${article.abstract}</p>
      `;
            // Only add "Read more" if URL is valid
            if (article.url && article.url !== "null") cardHTML += `<a href="${article.url}" target="_blank" class="text-yellow-400 hover:underline">Read more</a>`;
            card.innerHTML = cardHTML;
            $95697975ed728a4d$var$articlesContainer.appendChild(card);
        });
    } catch (error) {
        console.error("Error fetching top stories:", error);
        $95697975ed728a4d$var$articlesContainer.innerHTML = `<p class="text-red-500">Failed to load articles. Please try again later.</p>`;
    }
}
// Call the function
$95697975ed728a4d$var$fetchArticles();


//# sourceMappingURL=index.4caa4869.js.map
